import { Routes } from '@angular/router'

import { CompanyComponent } from './company.component'

export const COMPANY_ROUTES: Routes = [
  {
    path: '',
    component: CompanyComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('~/pages/company-info/company-info.routes').then(r => r.COMPANY_INFO_ROUTES),
      },
    ],
  },
]
